import React, { useEffect, useState } from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import Combobox from '../../Combobox.jsx';
import { CloseIcon } from '../../icons/CloseIcon.jsx';
import CustomSelectMenuItem from '../../CustomSelectMenuItem.jsx';

const GroupIndividualsSelect = (props) => {
  const {
    index,
    orgStakeholders,
    selectedGroupStakeholders,
    updateSelectedGroupStakeholders,
    customClass,
    isDisabled,
  } = props;

  // only individuals here
  const [filteredStakeholders, setFilteredStakeholders] = useState(null);

  const handleSelect = (individualId, showNotify) => {
    const stakeholder = selectedGroupStakeholders[index];
    const { individuals } = stakeholder;
    const isExist = individuals.includes(individualId);

    if (
      isExist &&
      showNotify &&
      !window.confirm('Are you sure you want to detach this stakeholder?')
    )
      return;

    const updatedIndividualIds = isExist
      ? individuals.filter((id) => id !== individualId)
      : [...individuals, individualId];

    updateSelectedGroupStakeholders(
      selectedGroupStakeholders.map((item) =>
        item.id === stakeholder.id
          ? { ...item, individuals: updatedIndividualIds }
          : item
      )
    );
  };

  const isActive = (stakeholder) =>
    selectedGroupStakeholders[index].individuals.includes(stakeholder.id);

  const onInputValueChange = (inputValue) =>
    filteredStakeholders.filter(({ fullName }) =>
      fullName.toLowerCase().includes(inputValue.toLowerCase())
    );

  const onSelectedItemChange = (stakeholder) => {
    if (isDisabled(stakeholder.id) && !isActive(stakeholder)) {
      return null;
    }

    handleSelect(stakeholder.id, false);
  };

  useEffect(() => {
    setFilteredStakeholders(
      orgStakeholders.filter((item) => item.objectType === 'individual')
    );
  }, [orgStakeholders]);

  return (
    <Row>
      {filteredStakeholders ? (
        <Col xs={12}>
          <ControlLabel>
            Select Individual Stakeholder(s)
            <strong className="bordered bordered-xs text-muted m-l-8">
              Total:&nbsp;
              <span className="text-info-brand count">
                {selectedGroupStakeholders[index].individuals.length}
              </span>
            </strong>
          </ControlLabel>
          <div className={`m-b-12 ${customClass}`}>
            <div className="bulk-select m-b-12">
              <div className="flex flex-align-start flex-wrap">
                {filteredStakeholders &&
                  selectedGroupStakeholders[index].individuals.map(
                    (individualId) => {
                      const stakeholder = filteredStakeholders.find(
                        ({ id }) => id === individualId
                      );
                      return (
                        <div
                          className="flex m-t-4 m-l-4 item-style"
                          key={`individual-${individualId}`}
                        >
                          {stakeholder
                            ? `${stakeholder.fullName} ${stakeholder.archived ? '(archived)' : ''}`
                            : ''}
                          <span
                            onClick={() => handleSelect(individualId, true)}
                            className="btn btn-clear close-btn"
                          >
                            <CloseIcon />
                          </span>
                        </div>
                      );
                    }
                  )}
              </div>
              <Combobox
                entities={filteredStakeholders}
                onInputValueChange={onInputValueChange}
                onSelectedItemChange={onSelectedItemChange}
                isActive={isActive}
                getItemName={(item) => item.fullName}
                placeholder="Start Typing"
                controlId="individual-stakeholder"
                customMenuItem={(comboboxProps) =>
                  CustomSelectMenuItem(comboboxProps, isActive, isDisabled)
                }
              />
            </div>
          </div>
        </Col>
      ) : null}
    </Row>
  );
};

export default GroupIndividualsSelect;
